export default "__VITE_ASSET__DVmlEris__"